import React, { ReactNode } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { LoadingWrapper } from '../styled';
import { SxProps } from '@mui/system';

interface DataLoadingProps {
    isLoading?: boolean;
    showNoData?: boolean;
    loadingMessage?: string | ReactNode;
    noDataMessage?: string | ReactNode;
    children?: ReactNode;
    sx?: SxProps;
}

const LoadingIndicator = () => <CircularProgress size={40} sx={{ color: 'common.primary' }} thickness={3} />;

const DataLoader: React.FC<DataLoadingProps> = ({
    sx,
    isLoading,
    loadingMessage,
    showNoData,
    noDataMessage,
    children,
}) => {
    if (isLoading) {
        return (
            <LoadingWrapper sx={sx}>
                <LoadingIndicator />
                {loadingMessage}
            </LoadingWrapper>
        );
    } else if (showNoData) {
        return <LoadingWrapper sx={sx}>{noDataMessage}</LoadingWrapper>;
    }
    return children || null;
};

export default DataLoader;
